import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { TranslateService } from '../../../api/translate.service';
import {
  fieldAddressLine1Col,
  fieldAddressLine2Col,
  fieldAmountCol,
  fieldApprovedByCol,
  fieldBuildingNameCol,
  fieldConfidentialityStatusCol,
  fieldCountryCol,
  fieldCreatedByCol,
  fieldCurrencyCol,
  fieldDateCol,
  fieldDistrictCol,
  fieldIdCol,
  fieldInvoiceIdCol,
  fieldInvoiceTypeCol,
  fieldIpMetroCol,
  fieldLocalityCol,
  fieldMiqIdCol,
  fieldOppNumberCol,
  fieldOpportunityCol,
  fieldOpportunityInstallmentCol,
  fieldOpportunitySourceCol,
  fieldPctCol,
  fieldPostcodeCol,
  fieldPrimaryEmployeeFunctionalUnitCol,
  fieldPrimaryEmployeeFunctionalUnitIdCol,
  fieldPrimaryEmployeeIdCol,
  fieldPrimaryEmployeeManagingOfficeCol,
  fieldPrimaryEmployeeManagingOfficeIdCol,
  fieldPrimaryEmployeeNameCol,
  fieldPropertyBaseIdCol,
  fieldPropertyTypeCol,
  fieldPurchaseOrderCol,
  fieldRegionCol,
  fieldRepresentedPartyCol,
  fieldRepRolCol,
  fieldSellerNameCol,
  fieldSubFeeTypeCol,
  fieldSubmittedByCol,
  fieldSuburbCol,
  fieldTeamCol,
  fieldTransactionTypeCol
} from '../../../utils/ag-grid/column-defs';

@Injectable({
  providedIn: 'root'
})
export class SaleDsfConsultingReportService {

  constructor(
    private translateService: TranslateService
  ) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [{
      header: this.translateService.getTranslation('FINISHLINE_ID'),
      key: 'finishline_id',
      width: 7,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('INVOICE_ID'),
      key: 'invoice_id',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('TRANSACTION_TYPE'),
      key: 'transaction_type',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('INVOICE_DT'),
      key: 'invoice_date',
      width: 20,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('INVOICE_TYPE'),
      key: 'invoice_type',
      width: 10,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('TEAM_ID'),
      key: 'team',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('CURRENCY'),
      key: 'currency',
      width: 20,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('OPPORTUNITY_NO'),
      key: 'opportunity_number',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('OPPORTUNITY_ID'),
      key: 'opportunity',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      key: 'opportunity_installment_id',
      width: 30,
      style: { ...settings.middle },
    }, {
      header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      key: 'opportunity_source',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('REP_ROLE'),
      key: 'rep_role',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('REPRESENTED_PARTY'),
      key: 'repped_customer',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('PURCHASE_ORDER'),
      key: 'purchase_order_number',
      width: 30,
      style: { ...settings.middle },
    }, {
      header: this.translateService.getTranslation('PROPERTY_TYPE'),
      key: 'property_type',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      key: 'miq_property_id',
      width: 20,
      style: { ...settings.middle },
    }, {
      header: this.translateService.getTranslation('BUILDING_NAME'),
      key: 'building_name',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('ADDRESS_LINE1'),
      key: 'address_line1',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('ADDRESS_LINE2'),
      key: 'address_line2',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('POSTAL_CODE'),
      key: 'postal_code',
      width: 30,
      style: { ...settings.middle }
    },
    {
      header: this.translateService.getTranslation('SUBURB'),
      key: 'suburb',
      width: 16,
      style: { ...settings.left },
    },
    {
      header: this.translateService.getTranslation('DISTRICT'),
      key: 'district',
      width: 16,
      style: { ...settings.left },
    },
    {
      header: this.translateService.getTranslation('LOCALITY'),
      key: 'locality',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('REGION'),
      key: 'region',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('COUNTRY'),
      key: 'country',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      key: 'primary_employee_id',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      key: 'primary_employee_name',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      key: 'primary_employee_functional_unit_id',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      key: 'primary_employee_functional_unit',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      key: 'primary_employee_managing_office_id',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      key: 'primary_employee_managing_office',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('FEE_TYPE'),
      key: 'fee_type',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('TRANSACTION_AMOUNT'),
      key: 'transaction_amount',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('FEE_STRUCTURE'),
      key: 'fee_structure',
      width: 30,
      style: { ...settings.middle }
    }, {
      header: this.translateService.getTranslation('CBRE_BASE_FEE_INCENTIVE').toUpperCase(),
      key: 'cbre_fee',
      width: 30,
      style: { ...settings.middle }
    },
    {
      header: this.translateService.getTranslation('SELLER_NAME'),
      key: 'seller_name', 
      width: 30,
      style: { ...settings.middle }
    },
    {
      header: this.translateService.getTranslation('PROPERTY_BASE_ID'),
      key: 'property_base_id',
      width: 30,
      style: { ...settings.middle }
    },
    {
      header: this.translateService.getTranslation('IP_METRO'), 
      key: 'ip_metro', 
      width: 30,
      style: { ...settings.middle }
    },
    {
      header: this.translateService.getTranslation('CREATED_BY'),
      key: 'created_by',
      width: 30,
      style: { ...settings.middle }
    },
    {
      header: this.translateService.getTranslation('SUBMITTED_BY'),
      key: 'submitted_by',
      width: 30,
      style: { ...settings.middle }
    },
    {
      header: this.translateService.getTranslation('APPROVED_BY'),
      key: 'approved_by',
      width: 30,
      style: { ...settings.middle },
    },
    {
      header: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
      key: 'confidentiality_status',
      width: 30,
      style: { ...settings.middle },
    },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      },
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },      
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },     
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },    
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },               
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },      
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      },     
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      }, 
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      }, 
      {
        ...fieldRepRolCol,
        field: 'rep_role',
        headerName: this.translateService.getTranslation('REP_ROLE'),
      },           
      {
        ...fieldRepresentedPartyCol,
        field: 'repped_customer',
        headerName: this.translateService.getTranslation('REPRESENTED_PARTY'),
      },   
      {
        ...fieldPurchaseOrderCol,
        field: 'purchase_order_number',
        headerName: this.translateService.getTranslation('PURCHASE_ORDER'),
      },     
      {
        ...fieldPropertyTypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE'),
      },
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },    
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },         
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },      
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },        
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },       
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },      
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      }, 
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },   
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },              
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },  
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },      
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },      
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },      
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },      
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },      
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      },     
      {
        ...fieldSubFeeTypeCol,
        field: 'fee_type',
        headerName: this.translateService.getTranslation('FEE_TYPE'),
      },        
      {
        ...fieldAmountCol,
        field: 'transaction_amount',
        headerName: this.translateService.getTranslation('TRANSACTION_AMOUNT'),
      },
      {
        ...fieldPctCol,
        field: 'fee_structure',
        headerName: this.translateService.getTranslation('FEE_STRUCTURE'),
      },
      {
        ...fieldAmountCol,
        field: 'cbre_fee',
        width: 200,
        headerName: this.translateService.getTranslation('CBRE_BASE_FEE_INCENTIVE').toUpperCase(),
      },
      {
        ...fieldSellerNameCol,
        headerName: this.translateService.getTranslation('SELLER_NAME'),
      },
      {
        ...fieldPropertyBaseIdCol,
        headerName: this.translateService.getTranslation('PROPERTY_BASE_ID'),
      },
      {
        ...fieldIpMetroCol,
        headerName: this.translateService.getTranslation('IP_METRO'),
      },
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },            
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },     
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      },   
      {
        ...fieldConfidentialityStatusCol,
        headerName: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
      }   
    ];
  }
}
